import getApiInstance from '@/api';
import { createAsyncThunk } from '@/store/utils';
import type {
  ConsentsResponseDTO,
  SalesPointConfigurationResponseDTO,
} from '@/types/dto/agent';
import type { TenantOption } from '@/types/tenant';
import { setTenantBrand, setTenantFavicon } from '@/utils/color';

export const setTenant = createAsyncThunk<TenantOption, TenantOption>(
  'configuration/setTenant',
  (tenant) => {
    setTenantBrand(tenant);
    setTenantFavicon(tenant);

    return tenant;
  }
);

export const getSalesPointConfiguration =
  createAsyncThunk<SalesPointConfigurationResponseDTO>(
    'configuration/getSalesPointConfiguration',
    async () => {
      const api = (await getApiInstance()).agentApi;

      return (await api.PointOfSaleConfiguration_GetSalesPointConfiguration())
        .data;
    }
  );

export const getConsents = createAsyncThunk<ConsentsResponseDTO>(
  'configuration/getConsents',
  async () => {
    const api = (await getApiInstance()).agentApi;

    return (await api.Consents_GetConsents()).data;
  }
);
